import "./About.css";
import aboutImg from "../assets/about.png";

export default function About() {
  return (
    <section className="about-section" id="about">

      {/* HEADER */}
      <div className="about-header">
        <span className="sub-title">ABOUT US</span>
        <h2>Know More About Us</h2>
      </div>

      {/* CONTENT */}
      <div className="about-container">

        {/* LEFT IMAGE */}
        <div className="about-left">
          <div className="img-box">
            <img src={aboutImg} alt="gold" />
          </div>
        </div>

        {/* RIGHT TEXT */}
        <div className="about-right">
          <p className="fade-up">
            Gold Company is an ISO certified leading Gold buyer in India. 
            We are known for buying, selling, and releasing pledged Gold 
            from any financial services.
          </p>

          <p className="fade-up delay1">
            Our highly trained experts evaluate using German technology 
            to provide the right value for your jewels. We strive to pay 
            the highest prices guaranteed in the market.
          </p>

          <p className="fade-up delay2">
            You can receive immediate cash for your gold via cheque, NEFT, 
            or online payment. Our customized solutions ensure the best 
            market price for your gold.
          </p>
        </div>

      </div>

    </section>
  );
}